import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Fetch the current year

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        padding: '1rem 0',
        borderTop: '1px solid',
        borderColor: 'divider',
        textAlign: 'center',
        marginTop: '2rem',
      }}
    >
      {/* Mission Statement */}
      <Typography
        variant="body2"
        sx={{ fontWeight: 'bold', marginBottom: '0.5rem', color: 'text.secondary' }}
      >
        Clairmont One is committed to Privacy, Security, and Simplicity.
      </Typography>

      {/* Dynamic Copyright and Personality */}
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
        }}
      >
        © {currentYear} Modern Password. All rights reserved.
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          marginTop: '0.5rem',
          fontStyle: 'italic',
          color: 'text.secondary',
        }}
      >
        Made with ❤️ to protect your digital life.
      </Typography>
    </Box>
  );
};

export default Footer;
